import { render, staticRenderFns } from "./ResetPasswordConfirm.vue?vue&type=template&id=c168ca74&"
import script from "./ResetPasswordConfirm.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports